import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './components/ui';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Overview from './pages/Overview';
import Tenants from './pages/Tenants';
import TenantDetail from './pages/TenantDetail';
import Notifications from './pages/Notifications';
import AuditLog from './pages/AuditLog';
import Security from './pages/Security';
import Health from './pages/Health';
import Account from './pages/Account';
import Team from './pages/Team';
import PortalAccounts from './pages/PortalAccounts';
import AssistantSecurity from './pages/AssistantSecurity';
import PlatformCredentials from './pages/PlatformCredentials';
import AcceptInvite from './pages/AcceptInvite';

function Protected({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/" element={<Protected><MainLayout /></Protected>}>
              <Route index element={<Overview />} />
              <Route path="tenants" element={<Tenants />} />
              <Route path="tenants/:id" element={<TenantDetail />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="audit" element={<AuditLog />} />
              <Route path="security" element={<Security />} />
              <Route path="health" element={<Health />} />
              <Route path="account" element={<Account />} />
              <Route path="team" element={<Team />} />
              <Route path="portal" element={<PortalAccounts />} />
              <Route path="assistant-security" element={<AssistantSecurity />} />
              <Route path="platform-credentials" element={<PlatformCredentials />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
